import React from "react";
import { Layout, message, Row, Col, Radio, Input, Modal, Menu } from "antd";
import TableWrapper from "../../elements/TableWrapper";
import moment from "moment";
import { Link } from 'react-router-dom';
import MiCompAPI from "../../../util/api";
import AddReports from "./AddReports";

const { Content } = Layout;
class Compliancereports extends React.Component {
  broker_columns = [
    {
      title: 'Report Name',
      dataIndex: 'report_Name',
      sorter: (a, b) => a.report_Name.localeCompare(b.report_Name),
      sortDirections: ["descend", "ascend"],
      render: (text, record) => {return <Link onClick={()=>{
        window.open(record.unq_Document_Name, "_blank")
      }}>{text}</Link>},
    },{
      title: 'Entity Name',
      dataIndex: 'entity_Name',
      sorter: (a, b) => a.entity_Name.localeCompare(b.entity_Name),
      sortDirections: ["descend", "ascend"]
    },{
      title: 'Entity Type',
      dataIndex: 'entity_Type',
      sorter: (a, b) => a.entity_Type.localeCompare(b.entity_Type),
      sortDirections: ["descend", "ascend"]
    }, {
      title: 'Uploaded  On',
      dataIndex: 'uploaded_On',
      render: (text, record) =>
        record["uploaded_On"] !== null && record["uploaded_On"] !== ""
          ? moment(record["uploaded_On"]).format("MM/DD/YYYY")
          : "",
      sorter: (a, b) => new Date(a.uploaded_On) - new Date(b.uploaded_On),
      sortDirections: ["descend", "ascend"]
    },{
      title: 'Uploaded  By',
      dataIndex: 'carrier_Name',
      sorter: (a, b) => a.carrier_Name.localeCompare(b.carrier_Name),
      sortDirections: ["descend", "ascend"]
    }];

  handleClick = (e) => {
    this.setState({
      currentTab: e.key,
    });
  };
  constructor(props) {
    super(props);
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;

    this.tableButtons = [];
    this.tableButtons.push({
      buttonType: "primary",
      content: "Add Reports",
      clickHandler: () => {
        this.setState({
          isModelVisble:true
        })
      },
    });
    this.state = {
      isLoading: true,
      reports:[],
      users:[],
      isModelVisble:false

    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    this.GetAllReports();
    this.getAgencies();
    this.getBrokers();
  }

  getAgencies = () => {
    this.api.invoke("BSU_GetAllAgencies", "get", (data, success) => {
        if (success) {
            if (data.statusCode === 200) {
                const Agencys = data.data;
                this.setState({ users:[...this.state.users,...Agencys.map(x=>{
                  return {id:x.user_Id,name:x.primary_Contact_First_Name+" "+x.primary_Contact_Last_Name+" (Agency)"}
                })] });
            } else {
                message.destroy();
                message.error(data.statusMessage, 3);
            }
        }
        else {
        }
    });
}
getBrokers() {
  this.api.invoke("BSU_GetAllBrokers", "get", (data, success) => {
      if (success) {
          if (data.statusCode === 200) {
              const brokers = data.data; 
              this.setState({ users:[...this.state.users,...brokers.map(x=>{        
              return {id:x.user_Id,name:x.first_Name+" "+x.last_Name+" (Broker)"}
            })] });
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
          }
      }
  });
}
handleSubmit = (values) => {
 
          this.api.invoke(
              "ReportInsert",
              "post",
              (data, success) => {
                  if (success) {
                      if (data.statusCode === 200) {
                          message.destroy();
                          message.success(data.statusMessage, 3);
                          this.GetAllReports();
                          this.adddocDefaultHandler();
                      } else {
                          message.destroy();
                          message.success(data.statusMessage, 3);
                      }
                  } else {
                      message.destroy();
                      message.success(data.statusMessage, 3);
                  }
              },
              values
          );   
}
  GetAllReports=()=>{ 
  
 
      this.api.invoke(
        "GetAllReports",
        "get",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
    
              this.setState({
                reports: data.data,
                isLoading: false,
              })
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        }
      );
    
    
   } 
   adddocDefaultHandler = () => {
    this.setState({ isModelVisble: !this.state.isModelVisble });
  }
  render() {
    return (
      <Content>
                {(this.state.isModelVisble) ? <Modal
          visible={this.state.isModelVisble}
        > <AddReports users={this.state.users} userPermandMasters={this.props.userPermandMasters}  closeDrawerHandler={this.adddocDefaultHandler} submitHandler={this.handleSubmit} width="500" /></Modal> : null}
        <div className="mi_main_div " style={{ paddingLeft: "10px" }}>          
          <Row style={{ marginRight: "12px" }}>
            <Col span={24}>
            <TableWrapper rowKey="id"
            buttons={this.tableButtons}
                columns={this.broker_columns}
                data={this.state.reports}
                loading={this.state.isLoading}
                title="Reports"
                search={true}
              />
            </Col>
          </Row>
        </div>
      </Content>
    );
  }
}
export default Compliancereports;
